import React from 'react';
import styled from 'styled-components/macro';
import { Alerts, AppBar } from '.';
import PreviewFile from '../main/PreviewFile';
import { OverlaysContainer } from '../overlays';

interface LayoutProps {
  isLoading?: boolean;
  pageName?: string;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  isLoading = false,
  pageName,
}) => {
  const renderVersion = () => {
    const version = process.env.REACT_APP_VERSION;
    return version ? (
      <SVersion>{`version: ${version}`}</SVersion>
    ) : null;
  };
  return (
    <SLayout>
      <AppBar pageName={pageName} />
      <SAppBarPad></SAppBarPad>
      <SBody>{children}</SBody>

      {/* preview pdf */}
      <PreviewFile />
      <Alerts />
      <OverlaysContainer />
      {renderVersion()}
    </SLayout>
  );
};

export default Layout;

const SLayout = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const SBody = styled.div`
  flex: 1;
  background: ${(props) => props.theme.palette.background.default};
  overflow: auto;
  font-size: ${(props) => props.theme.typography.fontSize.body};
`;
const SAppBarPad = styled.div`
  height: 4rem;
`;
const SVersion = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  color: ${(props) => props.theme.palette.grey[500]};
  margin: 0.5rem;
  font-size: 0.7rem;
`;
